import { render } from "./EventContactDonation.vue?vue&type=template&id=5b461420&scoped=true"
import script from "./EventContactDonation.vue?vue&type=script&lang=js"
export * from "./EventContactDonation.vue?vue&type=script&lang=js"

import "./EventContactDonation.vue?vue&type=style&index=0&id=5b461420&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b461420"]])

export default __exports__